(function () {
  'use strict';

  // Search terms are limited to letters, numbers and single spaces. Every other
  // character is removed, so "t-shirt" becomes "tshirt". A letter is any character
  // with distinct upper and lower case forms, so accented letters ("rosé") are kept.
  // snippets/search-terms-clean.liquid applies the same rule to the server-rendered page.
  const DIGITS = /[0-9]/;
  const REPEATED_SPACES = / {2,}/g;
  const SEARCH_INPUT_SELECTOR = '.aa-Input, .ais-SearchBox-input, input[name="q"], #quick-search-c';

  const isAllowed = (character) => character === ' ' || DIGITS.test(character) || character.toLowerCase() !== character.toUpperCase();
  const removeSymbols = (value) => Array.from(value).filter(isAllowed).join('');

  // A trailing space is kept while typing so the next word can be started.
  const cleanWhileTyping = (value) => removeSymbols(String(value ?? '')).replace(REPEATED_SPACES, ' ').trimStart();
  const clean = (value) => cleanWhileTyping(value).trimEnd();

  const cleanInput = (input) => {
    const cleaned = cleanWhileTyping(input.value);
    if (cleaned === input.value) return false;

    const caret = cleanWhileTyping(input.value.slice(0, input.selectionStart ?? input.value.length)).length;
    input.value = cleaned;
    input.setSelectionRange(caret, caret);
    return true;
  };

  // Runs in the capture phase, before Algolia and theme listeners on the input
  // read its value, so a symbol is never searched for or shown.
  const handleSearchInput = (event) => {
    if (event.isComposing || !event.target.matches?.(SEARCH_INPUT_SELECTOR)) return;
    cleanInput(event.target);
  };

  // Changing the value mid-composition breaks mobile keyboards, so clean once
  // composition ends and tell the search scripts about the new value.
  const handleCompositionEnd = (event) => {
    if (!event.target.matches?.(SEARCH_INPUT_SELECTOR)) return;
    if (cleanInput(event.target)) event.target.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const tidySearchAddress = () => {
    const url = new URL(window.location.href);
    const query = url.searchParams.get('q');
    const needsCleaning = query !== null && query !== clean(query);
    if (!needsCleaning && !url.hash) return;

    if (needsCleaning) url.searchParams.set('q', clean(query));
    // A "#" typed into a search address cuts the query short, so drop the leftover fragment.
    url.hash = '';
    window.history.replaceState(window.history.state, '', url);
  };

  window.theme.searchTerms = { clean };

  document.addEventListener('input', handleSearchInput, true);
  document.addEventListener('compositionend', handleCompositionEnd, true);

  if (/\/search\/?$/.test(window.location.pathname)) tidySearchAddress();
})();
